import { z } from 'zod';

export const MessageType = z.enum([
  'hide-fab',
  'hide-fab-transition-complete',
  'hide-support-window',
  'hide-support-window-transition-complete',
  'show-fab',
  'show-fab-transition-complete',
  'show-support-window',
  'show-support-window-transition-complete',
  'show-hidden',
  'show-hidden-transition-complete',
  'simplr-initiate-chat',
  'transition-to-fab',
  'transition-to-hidden',
  'transition-to-support-window',
]);
